import React from 'react';

export default (props) => {  
  return (
    <section className="firstSection">
      <div className="">
        <div className="contenido-center_flex" style={{ marginBottom: 24 }}>
          <img src="/img/Logo-box.svg" alt="logo" />
        </div>
        <div className="contenido-center_flex" style={{ margin: 0 }}>
          <p className="texto-indica">Abogado, crea tu cuenta</p>
        </div>
      </div>
    </section>
  );
};
